module.exports = __webpack_public_path__ + "img/mobile-image-hero-3.39ee9deb.jpg";